/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Auth_Legal_Last_UpdatedInputs */

const en_auth_legal_last_updated = /** @type {(inputs: Auth_Legal_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last updated: {date}" |
*
* @param {Auth_Legal_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_legal_last_updated = /** @type {((inputs: Auth_Legal_Last_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_Last_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_legal_last_updated(inputs)
});